import React, { useCallback, useState } from "react";
import * as styles from "./rules-editor-deactivatable-section.module.scss";
import RulesEditorSection from "./rules-editor-section";
import { classArr } from "../../../helper/style-helper";
import VelavuIconButton from "../../../elements/velavu-icon-button";
import IconClose from "../../../dynamicicons/icon-close";
import IconDelete from "../../../dynamicicons/icon-delete";
import IconCollapse from "../../../dynamicicons/icon-collapse";
import IconChevronLeft from "../../../dynamicicons/icon-chevron-left";
import IconArrowDropDown from "../../../dynamicicons/icon-arrow-drop-down";
import { useToggleable } from "../../../helper/hook-helper";
import IconArrowDropUp from "../../../dynamicicons/icon-arrow-drop-up";
import whitelabel from "../../../whitelabel";

export interface RulesEditorDeactivatableSectionProps {
	className?: string;
	title: string;
	onDeactivate?: () => void;
	deactivateDisabled?: boolean;
	deactivateTooltip?: string;
	children?: React.ReactNode;
}

export function RulesEditorDeactivatableSection(
	props: RulesEditorDeactivatableSectionProps,
) {
	const [isExpanded, setIsExpanded] = useState(true);
	const toggleExpanded = useCallback(() => {
		setIsExpanded((prev) => !prev);
	}, [setIsExpanded]);

	return (
		<RulesEditorSection
			className={classArr(
				isExpanded
					? styles.containerExpanded
					: styles.containerCollapsed,
				props.className,
			)}
		>
			<div className={styles.toolbar}>
				<VelavuIconButton onClick={toggleExpanded} small>
					{isExpanded ? (
						<IconArrowDropDown
							color={whitelabel.palette.secondary900}
						/>
					) : (
						<IconArrowDropUp
							color={whitelabel.palette.secondary900}
						/>
					)}
				</VelavuIconButton>

				<span className={styles.label}>{props.title}</span>

				<VelavuIconButton
					onClick={props.onDeactivate}
					small
					disabled={props.deactivateDisabled}
					tooltip={props.deactivateTooltip}
				>
					<IconDelete color={whitelabel.palette.secondary700} />
				</VelavuIconButton>
			</div>

			{isExpanded && props.children}
		</RulesEditorSection>
	);
}
